export const SEARCH_CRITERIA = {
	ALL: 'all',
	POSTS: 'post',
	PRODUCTS: 'product',
};

export const WIDTH_OPTIONS = [ 25, 50, 75, 100 ];

export const DEBOUNCE_MS = 300;
export const MIN_SEARCH_LENGTH = 2;
